import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import {
  FACILITYEMISSION_API,
  FACILITYEMISSION_EXPORT_API,
  FACILITYEMISSION_GETALL_API,
  FACILITYEMISSION_EXPORT_WITH_IDS_API,
} from './config';

export function getList(query) {
  // console.log(`${FACILITYEMISSION_API()}`)
  // console.log(query, 'getList==query')
  return getFetch(`${FACILITYEMISSION_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${FACILITYEMISSION_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${FACILITYEMISSION_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${FACILITYEMISSION_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${FACILITYEMISSION_API()}`, obj);
}

export function exportData(query) {
  // return window.location.href  = FACILITYEMISSION_EXPORT_API
  return getFetch(`${FACILITYEMISSION_EXPORT_API()}`, {
    ...query,
  });
}

export function getAll() {
  return getFetch(`${FACILITYEMISSION_GETALL_API()}`);
}

export function exportDataWithIds(query) {
  return postFetch(`${FACILITYEMISSION_EXPORT_WITH_IDS_API()}`, {
    ...query,
  });
}



// WEBPACK FOOTER //
// ./src/api/facilityemissionApi.js